import { render } from "./DetentionsAndAppointmentsTable.vue?vue&type=template&id=6c937159"
import script from "./DetentionsAndAppointmentsTable.vue?vue&type=script&lang=js"
export * from "./DetentionsAndAppointmentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__